//sign map
//map/Map.js
import React from "react";
//import "./styles.css";
//moment
import moment from 'moment';
//import 'moment-precise-range-plugin';

import GoogleMap from "google-map-react";
//import MCircle from "./marker/Circle";
import Pointer from "./marker/Pointer";



export default function Gps(props) {
	const {locations, width, height, onClick, className} = props;
	const [size, setSize] = React.useState({
		width: 250,
		height:230
	});
	const [center, setCenter] = React.useState({
		lat:33.862532, 
		lng: -117.802847
	});
	const [ gmap, setGmap ] = React.useState({});
	//const [ gmaps, setGmaps ] = React.useState({});
	//const [ zoom, setZoom ] = React.useState(16);
	const [ points, setPoints ] = React.useState([]);
	const [ loaded, setLoaded ] = React.useState(false);
	const extractLatLng = (loc) => {
		if(loc.lat && loc.lon){
            return {
                lat : loc.lat,
                lng : loc.lon,
                reltime : moment(loc.date).fromNow(),
            }
		}
		return {
			lat: 0,
			lng: 0
		}
	};
	const validate = (loc) => {
        return !isNaN(loc.lat.toString()) 
            && !isNaN(loc.lon.toString());
    }
	
	const loadMap = (map, maps) => {
		setGmap(map);
		//setGmaps(maps);
		setLoaded(true);
	}
	//refresh on prop updates
	React.useEffect(() => {
		var spoints = [];
		if(locations){
			spoints = locations.filter(validate);
			if(spoints.length > 0){
				setPoints(spoints);
				setCenter(extractLatLng(spoints[spoints.length-1]));
			}
		}
		//console.log(spoints);
		var newSize = Object.assign({}, size);
		if(width){
			newSize.width = width;
		}
		if(height){
			newSize.height = height;
		}
		setSize(newSize);
		
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	React.useEffect(() => {
		if(loaded)
		gmap.panTo(center);
       // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [center])
  return (
	  <div style={{height: '100%', width: '100%', minHeight:size.height, minWidth:size.width}} className={className}>
      <GoogleMap
        bootstrapURLKeys={{
          // remove the key if you want to fork
          key: process.env.REACT_APP_MAP_API_KEY,
          language: "en",
          region: "US"
        }}
        defaultCenter={{
			lat:33.862532, 
			lng: -117.802847
		}}
        defaultZoom={16}
	  	onGoogleApiLoaded={({map, maps}) => loadMap(map, maps)}
      >
        {points.map((sign, n) => {
	  		var cord = extractLatLng(sign);
          return (
            <Pointer key={n} id={n} lat={cord.lat} lng={cord.lng} text={cord.reltime} tooltip={cord.reltime} onClick={onClick} />
          );
        })}
      </GoogleMap>
	</div>
  );
}
